<template>
  <div class="loading-spinner">
    <img style="width: 9%; height: 9%;" src="../assets/img/loading.svg" alt="Loading..." />
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.loading-spinner {
  position: fixed;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  z-index: 999999;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.1);
}
</style>
